const BASE_ASSETS = "./";

const BASE_SPRITES = BASE_ASSETS + "sprites/1280x800/";

export const ASSETS = {
  'aarbon': BASE_SPRITES + 'aarbonRun@2x.png',
  'sky': BASE_ASSETS + "sprites/640x400/" + 'sky.png',
  'moon': BASE_SPRITES + 'luna@2x.png',
  'barriere': BASE_SPRITES + 'barriere@2x.png',
  'erba0': BASE_SPRITES + 'herbe0@2x.png',
  'erba1': BASE_SPRITES + 'herbe1@2x.png',
  'erba2': BASE_SPRITES + 'herbe2@2x.png',
  'erba3': BASE_SPRITES + 'herbe3@2x.png',
  'erba4': BASE_SPRITES + 'herbe4@2x.png',
  'nuv0': BASE_SPRITES + 'nuages0@2x.png',
  'nuv1': BASE_SPRITES + 'nuages1@2x.png',
  'nuv2': BASE_SPRITES + 'nuages2@2x.png',
  'nuv3': BASE_SPRITES + 'nuages3@2x.png',
  'nuv4': BASE_SPRITES + 'nuages4@2x.png',
  'montagne': BASE_SPRITES + 'montagnes@2x.png'
};